/* -----------------------------------------------------------------------------
 * Security SM State
 *
 * @description - State of Security SM. Check ./README.md for more info.
 * -----------------------------------------------------------------------------
 */

import { getCSRFToken } from '@/utils/security'

export default {
  csrf: getCSRFToken(), // csrf token str or null
  token: '', // verification token
  callback: null, // send message callback function or null
  location: {
    href: '',
    hostname: '',
    search: ''
  },
  events: [] // complete events list
}
